import './MiddleBlock.css';

export default function MiddleBlock({ children }) {
    return (
        <div className="block">
            { children }
        </div>
    )
}